import { createConsumer } from "@rails/actioncable";

export const cable = createConsumer();
